<template>
  <div class="config-panel">
    <h3>Sync Configuration</h3>
    <div v-if="loading" class="loading">Loading configuration...</div>
    <div v-else class="config-form">
      <div class="config-item">
        <label>
          <input 
            type="checkbox" 
            v-model="config.autoSyncEnabled"
            @change="saveConfig"
          />
          Auto Sync Enabled
        </label>
      </div>
      
      <div class="config-item">
        <label>
          <input 
            type="checkbox" 
            v-model="config.leadToJobEnabled"
            @change="saveConfig"
          />
          Job / Opportunity Sync Enabled
        </label>
      </div>
      
      <div class="config-item" v-if="config.leadToJobEnabled">
        <label>
          Job Sync Direction:
          <select v-model="config.jobSyncDirection" @change="saveConfig" class="select-field">
            <option value="ghl_to_sm8">{{ brand.agencyName }} → ServiceM8</option>
            <option value="sm8_to_ghl">ServiceM8 → {{ brand.agencyName }}</option>
            <option value="both">Both Directions</option>
          </select>
        </label>
      </div>
      
      <div class="config-item">
        <label>
          <input 
            type="checkbox" 
            v-model="config.contactSyncEnabled"
            @change="saveConfig"
          />
          Contact Sync Enabled
        </label>
      </div>
      
      <div class="config-item" v-if="config.contactSyncEnabled">
        <label>
          Contact Sync Direction:
          <select v-model="config.syncDirection" @change="saveConfig" class="select-field">
            <option value="ghl_to_sm8">{{ brand.agencyName }} → ServiceM8</option>
            <option value="sm8_to_ghl">ServiceM8 → {{ brand.agencyName }}</option>
            <option value="both">Both Directions</option>
          </select>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { brandMixin } from '../brandMixin'

export default {
  name: 'ConfigPanel',
  mixins: [brandMixin],
  data() {
    return {
      config: {
        autoSyncEnabled: false,
        leadToJobEnabled: false,
        jobSyncDirection: 'both',
        contactSyncEnabled: false,
        syncDirection: 'both',
      },
      loading: true,
      saving: false,
    }
  },
  async mounted() {
    await this.loadConfig();
  },
  methods: {
    async loadConfig() {
      this.loading = true;
      try {
        const ssoToken = await this.getSSOToken();
        const response = await fetch('/servicem8/config', {
          method: 'GET',
          headers: {
            'x-sso-token': ssoToken,
          },
        });

        if (response.ok) {
          this.config = await response.json();
        }
      } catch (error) {
        console.error('Error loading config:', error);
      } finally {
        this.loading = false;
      }
    },
    async saveConfig() {
      this.saving = true;
      try {
        const ssoToken = await this.getSSOToken();
        const response = await fetch('/servicem8/config', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-sso-token': ssoToken,
          },
          body: JSON.stringify(this.config),
        });

        if (response.ok) {
          const updated = await response.json();
          this.config = updated;
        }
      } catch (error) {
        console.error('Error saving config:', error);
        alert('Failed to save configuration');
      } finally {
        this.saving = false;
      }
    },
    async getSSOToken() {
      return await new Promise((resolve) => {
        window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
        window.addEventListener("message", ({ data }) => {
          if (data.message === "REQUEST_USER_DATA_RESPONSE") {
            resolve(data.payload);
          }
        });
      });
    }
  }
}
</script>

<style scoped>
.config-panel {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 20px;
}

.config-form {
  margin-top: 15px;
}

.config-item {
  margin-bottom: 15px;
  padding: 10px;
  background: white;
  border-radius: 6px;
}

.config-item label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.select-field {
  margin-left: 10px;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>

